import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import SiteNav from '../../components/layout/SiteNav';

export default function SiteLayout() {
  return (
    <>
      <ToastContainer limit={1} />
      <SiteNav />
      <Outlet />
    </>
  );
}

